import { useState, useEffect } from "react";

// Today, 30 Sept 2026, 5:00 PM West Africa Time (UTC+1)
const DEADLINE = new Date("2026-09-30T17:00:00+01:00").getTime();

const MESSAGE =
  "Closing today by 5:00 PM: LUTH College of Nursing Science, School of Anaesthetic Technicians, Federal School of Biomedical Engineering and School of Medical & Psychiatric Social Work.";

const pad = (n) => String(n).padStart(2, "0");

function getLeft() {
  const diff = Math.max(DEADLINE - Date.now(), 0);
  return {
    diff,
    h: Math.floor(diff / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000),
  };
}

const styles = {
  wrapper: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    margin: "0 16px",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },
  text: {
    flex: 1,
    minWidth: 0, 
    position: "relative",
    fontSize: 16,
    lineHeight: 1.35,
    fontWeight: 600,
    color: "#842029",
  },
  timer: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  box: {
    minWidth: 34,
    padding: "3px 4px",
    borderRadius: 4,
    backgroundColor: "#842029",
    color: "#fff",
    textAlign: "center",
    lineHeight: 1.1,
  },
  num: { fontSize: 18, fontWeight: 800, display: "block" },
  lbl: { fontSize: 10, textTransform: "uppercase", opacity: 0.85 },
  colon: { fontWeight: 700, color: "#842029" },
  closed: { fontSize: 12, fontWeight: 700, color: "#842029" },
};

export default function NavbarClosingNotice({
  padding = "0",
  fontSize = 18,
  hideBelow = 1000,
}) {
  const [left, setLeft] = useState(getLeft());
  const [typed, setTyped] = useState(0);
  const [cursorOn, setCursorOn] = useState(true);
  const [narrow, setNarrow] = useState(window.innerWidth < hideBelow);

  useEffect(() => {
    const id = setInterval(() => setLeft(getLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  // typing effect: type one character at a time, pause at the end, then restart
  useEffect(() => {
    const done = typed >= MESSAGE.length;
    const t = setTimeout(() => setTyped(done ? 0 : typed + 1), done ? 3000 : 40);
    return () => clearTimeout(t);
  }, [typed]);

  // blinking cursor
  useEffect(() => {
    const id = setInterval(() => setCursorOn((v) => !v), 500);
    return () => clearInterval(id);
  }, []);

  // hide on small screens where there is no room
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < hideBelow);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (narrow) return <div style={{ flex: 1 }} />;

  const units = [
    { v: left.h, l: "Hrs" },
    { v: left.m, l: "Min" },
    { v: left.s, l: "Sec" },
  ];

  return (
    <div style={{ ...styles.wrapper, padding }}>
      <div style={{ ...styles.text, fontSize }}>
  {/* invisible full message: reserves the exact height needed */}
  <span style={{ visibility: "hidden" }}>{MESSAGE}|</span>

  {/* visible typing text sits on top of it */}
  <span style={{ position: "absolute", top: 0, left: 0, right: 0 }}>
    {MESSAGE.slice(0, typed)}
    <span style={{ opacity: cursorOn ? 1 : 0 }}>|</span>
  </span>
</div>

      {left.diff > 0 ? (
        <div style={styles.timer}>
          {units.map((u, i) => (
            <div key={u.l} style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <div style={styles.box}>
                <span style={styles.num}>{pad(u.v)}</span>
                <span style={styles.lbl}>{u.l}</span>
              </div>
              {i < units.length - 1 && <span style={styles.colon}>:</span>}
            </div>
          ))}
        </div>
      ) : (
        <span style={styles.closed}>Closed</span>
      )}
    </div>
  );
}